const _edit_modes = ['not_editing', 'editing'] as const;
export type _EditModesTuple = typeof _edit_modes;
export type EditMode = _EditModesTuple[number];
export const AVAILABLE_EDIT_MODES: ReadonlyArray<EditMode> = _edit_modes;